<template>
  <div class="varieties">
    <el-row :gutter="20" style="position: relative;">
      <div class="moblie-show classification-class" :class="{'classification-class-2': showClassification}" @click="showClassification=!showClassification"><i class="el-icon-s-unfold"></i><br/>饲<br/>料<br/>添<br/>加<br/>剂<br/>品<br/>种<br/>分<br/>类</div>
      <el-col :span="5" :class="{'openSection': showClassification}">
        <div style="height: 100%;" @click="showClassification=!showClassification">
          <div class="grid-content " style="overflow-x: hidden;">
            <v-navbar @itemfun='parentEvent'></v-navbar>
          </div>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="grid-content" :class="{'inner-box': isInnerBox}">
          <h2>{{$route.query.name}}</h2>
          <el-form :inline="true" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="170px" class="demo-ruleForm" :class="{flex:isFlex}">
            <el-form-item label="添加剂类别：" prop="catname">
              <el-select v-model="ruleForm.catname" placeholder="请选择类别">
                <el-option v-for="(item,index) in leftMenu.navList" :key="index" :label="item.catname" :value="item.catid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通用名称（中英文）：" prop="title" @keyup.enter.native="submitForm('ruleForm')">
              <el-input v-model="ruleForm.title" placeholder="请输入通用名称（中英文）
              "></el-input>
            </el-form-item>
            <el-form-item label="适用范围（中英文）：" prop="fanwei" @keyup.enter.native="submitForm('ruleForm')">
              <el-input v-model="ruleForm.fanwei" placeholder="请输入适用范围（中英文）"></el-input>
            </el-form-item>
            <el-form-item class="search-2">
              <el-button type="primary" @click="submitForm('ruleForm')">搜索</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
          <!-- pc端表格 -->
          <el-table
          class="pc-show"
          v-loading="loading"
          :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
          :data="tableData"
          border
          stripe
          style="width: 100%">
            <el-table-column
              prop="catname"
              label="类别"
              min-width="15%">
            </el-table-column>
            <el-table-column
              prop="title"
              label="通用名称（中文）"
              min-width="30%">
              <template slot-scope="scope">
                <div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
                <!-- <router-link :to="{name: 'varietiesArticle', query:{itemid:scope.row.itemid}}">{{scope.row.title}}</router-link> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="en_title"
              label="通用名称（英文）"
              min-width="40%">
            </el-table-column>
            <el-table-column
              prop="fanwei"
              label="适用范围"
              min-width="15%">
            </el-table-column>
          </el-table>
          <!-- 手机端表格 -->
          <el-table
          class="moblie-show"
          v-loading="loading"
          :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
          :data="tableData"
          border
          stripe
          style="width: 100%">
            <el-table-column
              fixed="left"
              prop="catname"
              label="类别"
              width="100px">
            </el-table-column>
            <el-table-column
              prop="title"
              label="通用名称（中文）"
              width="200px">
              <template slot-scope="scope">
                <div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
                <!-- <router-link :to="{name: 'varietiesArticle', query:{itemid:scope.row.itemid}}">{{scope.row.title}}</router-link> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="en_title"
              label="通用名称（英文）"
              width="200px">
            </el-table-column>
            <el-table-column
              prop="fanwei"
              label="适用范围"
              width="100px">
            </el-table-column>
          </el-table>

          <div class="block">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="current_page"
              :page-sizes="[10, 30, 50]"
              :page-size="per_page"
              layout="total, prev, pager, next, sizes, jumper"
              :total="total">
            </el-pagination>
          </div>


        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import navbar from './navbar_varieties.vue'
export default {
  name: 'varieties',
  data() {
    let checkwhitename = (rule, value, callback) => {
      if (!this.ruleForm.catname && !this.ruleForm.title && !this.ruleForm.fanwei) {
        return callback(new Error("请至少填写一项"))
      }else{
        return callback();
      }
    };
    return {
      isInnerBox: true,
      isFlex: true,
      ruleForm: {
          title: '',
          catname: '',
          fanwei: '',
          resource: '',
      },
      rules: {
        // title: [
        //   //{ required: true, message: '请输入通用名称', trigger: 'blur' },
        //   { validator: checkwhitename, trigger: 'blur' }
        // ],
        // fanwei: [
        //   {  validator: checkwhitename, trigger: 'blur' },
        //   // { min: 1, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        // ],
        // catname: [
        //   { validator: checkwhitename, trigger: 'change' }
        // ],
      },
      tableData: [],
      leftMenu: {
        navList: [],
      },
      current_page: 1,
      per_page: 10,
      total: 10,
      loading: true,
      showClassification: false,
    };
  },
  components: {
    'v-navbar':navbar
  },
  activated() {
  	this.ruleForm= {
  	    title: '',
  	    catname: '',
  	    fanwei: '',
  	    resource: ''
  	}
    this.initTableData();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
		  this.current_page = 1
          this.initTableData();
        } else {
          this.$message.error('请输入正确的搜索内容');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.initTableData();
    },
    handleSizeChange(val) {
      this.per_page = val
      this.initTableData();
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.initTableData();
    },
    initNavList(){
      this.loading = true ;
      this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=additive_cate').then(resp=>{
        this.loading = false ;
        if(resp){
          this.leftMenu.navList = resp.data.data;
        }
      })
    },
    initTableData(i){
      //this.current_page = 1 || this.current_page
      this.loading = true;
      this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=additive_list&title=' + this.title + '&fanwei' + this.fanwei + '&catid' + this.catid,{
        params: {
          title: this.ruleForm.title,
          fanwei: this.ruleForm.fanwei,
          catid: this.ruleForm.catname,
          page: this.current_page,
          num: this.per_page,
        }
      }).then(resp=>{
        this.loading = false ;
        if(resp){
          this.tableData = resp.data.data.data;
          this.total = resp.data.data.total;
        }
      })
    },
    parentEvent(val){
		this.ruleForm= {
		    title: '',
		    catname: '',
		    fanwei: '',
		    resource: ''
		}
      this.ruleForm.catname = Number(val);
      this.initTableData();
    },
	toDetail(itemid){
		const routeUrl = this.$router.resolve({
	    name: 'varietiesArticle',
	    query: { itemid: itemid,current: 4 }
	  })
	  window.open(routeUrl.href, '_blank')
	}
  },
  mounted() {
    this.initNavList();
  },
}
</script>

<style scoped>

.button-title{color: #2469B7;cursor: pointer;}
.varieties{
  position: relative;
  width: calc(100% + 120px);
  margin-left: -60px;
  margin-top: -30px;
  background-color: #f7f7f7;
  overflow: hidden;
}
.inner-box{
  margin: 20px 20px 0 0;
  padding: 10px 40px 40px;
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
}
.cell a{
  color: #2469B7;
  text-decoration: none;
}
.varieties /deep/ .el-form-item__label {
  width: auto !important;
}
.varieties > .el-row{
  display: flex;
}
.varieties > .el-row > .el-col.el-col-5 > div > .grid-content{
  height: 100%;
  padding: 0 10px;
  background-color: #fff;
}

@media screen and (max-width:1440px) {
  .flex{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .el-form-item{
    width: 45%;
  }
  .varieties /deep/ .el-form-item__label {
    width: 100px !important;
  }
  .varieties /deep/ .el-form-item__content{
    width: calc(100% - 100px) !important;
  }
  .el-select{
    width: 100%;
  }
  .varieties /deep/ .el-select-dropdown__wrap{
    margin-bottom: 0;
  }
}
@media screen and (max-width: 750px) {
  h2{
    padding: 0;
  }
  .el-col.el-col-5{
    position: fixed;
    top: 0;
    right: auto;
    bottom: 0;
    left: -750PX;
    width: auto;
    padding: 0 !important;
    overflow: auto;
    z-index: 999;
    transition: all 0.3s;
  }
  .el-col.el-col-5.openSection{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: all 0.3s ease-out;
  }
  .el-col.el-col-5.openSection > div{
    background-color: rgba(0, 0, 0, 0.3);
  }
  .varieties{
    width: 100%;
    margin: 0;
    background-color: #fff;
  }
  .varieties > .el-row{
    margin: 0 !important;
  }
  .el-col-19{
    width: 100%;
    padding: 0 !important;
  }
  .inner-box{
    margin: 0;
    padding: 0 0 40px;
    background: #fff;
    box-shadow: none;
    border-radius: 0;
    box-sizing: border-box;
  }
  .search-2 /deep/ .el-form-item__content{
    display: flex;
    justify-content: flex-end;
  }
  .search-2 /deep/ .el-form-item__content button{
    width: 100px;
  }
  .varieties > .el-row > .el-col.el-col-5 > div > .grid-content{
    width: 70%;
    background-color: #fff;
    overflow-y: auto;
  }
  .classification-class{
    position: fixed;
    left: 0px;
    top: 40%;
    padding: 8px;
    font-size: 14px;
    color: #666;
    line-height: 1.1;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 1px 6px rgba(0, 0, 0, .3);
    border-radius: 0 4px 4px 0;
    z-index: 99;
  }
  .classification-class i{
    margin-bottom: 4px;
    font-size: 16px;
    color: #2469B7;
  }
  .classification-class-2{
    left: calc(70% + 20px);
    z-index: 9999;
    box-shadow: none;
    transition: all 0.4s;
  }
  .classification-class-2 i{
    transform: rotate(180deg);
  }
  .el-form--inline .el-form-item {
    width: 100%;
    margin-right: 0;
  }
  .varieties /deep/ .el-form-item__label {
    width: 100% !important;
  }
  .varieties /deep/ .el-form-item__content{
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/varieties.vue